// src/pages/ReadmeViewer.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';

const DefaultsViewer = () => {
  const { file } = useParams(); // From URL
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    fetch(`/defaults/${file}.md`)
      .then(res => res.text())
      .then(setMarkdown)
      .catch(() => setMarkdown('# Error: README not found'));
  }, [file]);

  return (
    <div style={{ padding: 20, color:"#fff", height:"100%" }}>
      <ReactMarkdown>{markdown}</ReactMarkdown>
    </div>
  );
};

export default DefaultsViewer;
